import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// import Admissionleft from './Admissoinleft';
import { Container, Row, Col, Button,Table } from 'react-bootstrap';
import Fade from 'react-bootstrap/Fade';
import Scholarshipleft from '../Scholarships/Scholarshipleft'

function Institute_PGscholarshipsEle() {

    const [datesOpen, setDatesOpen] = useState(true);
    const [guidelinesOpen, setGuidelinesOpen] = useState(false);
    
    
    const handleClick = (event) => {
        setDatesOpen(false);
        setGuidelinesOpen(false);       
        event(true);
    }

    return (
        <section className="project-detail">
            <Container>
                <Row>
                    <Col md={4} className='c-left custom-padding-color mb-4'>
                        
                        <Scholarshipleft activeIndex={1} />
                    </Col>

                    <Col md={8} className='c-right text-center'>

                        <div className="c-heading">
                            <h3>Scholarships for PG Students (M.Sc., MPP)</h3> <br />
                        </div>
                        
                        <Row className='mb-5'>
                            {/* /backup xs={6} sm={4} md={3} lg={3}/ */}
                            <Col xs={6} sm={6} md={6} lg={6} className="mb-3 me-1">
                                <Button className='btn-sm'
                                    onClick={() => handleClick(setDatesOpen)}
                                    aria-controls="example-fade-text"
                                    aria-expanded={datesOpen}>
                                    Eligibilty criteria & Amount of scholarship
                                </Button>
                            </Col>

                            <Col xs={6} sm={6} md={6} lg={6} className="mb-3 ">
                                <Button className='btn-sm '
                                    onClick={() => handleClick(setGuidelinesOpen)}
                                    aria-controls="c-guidelines"
                                    aria-expanded={guidelinesOpen}>
                                    Apply online
                                </Button>
                            </Col>

                        </Row>


                        {/*dates */}
                    <div>
                        {datesOpen && <Fade in={datesOpen}>
                                <div className='lower-content'>


                                    <Table className='table table-bordered mb-40'>
                                        <thead>
                                            <tr>
                                                <th colSpan={4} rowSpan={2} className='c-noformat'>Scholarships for PG Students (M.Sc & MPP)</th>
                                            </tr>
                                            <tr></tr>
                                            <tr>
                                                <th colSpan={4} className='c-noformat'>Eligibility Criteria & Amount of Scholarship</th>
                                            </tr>
                                  
                                            <tr>
                                                <th>S.No.</th>
                                                <th>Scholarships</th>
                                                <th>Eligibility</th>
                                                <th>Amount of scholarship</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>Merit-cum-Means Scholarship</td>
                                                <td>
                                                    On the basis of the performance at the end of the first semester, 25% of the students admitted or 25% of the sanctioned strength whichever is less will be awarded Merit Scholarship for the first two semesters of the programme and renewal for III & IV semesters will be based on the performance in the II & III semesters.
                                                </td>
                                                <td>Rs.1000/- per month and exemption of Tuition Fees</td>
                                            </tr>
                                            <tr>
                                                <td>2</td>
                                                <td> Free Studentship</td>
                                                <td>
                                                    In addition to the Merit Scholarship, 10% of the students admitted or 10% of the sanctioned strength whichever is less will be awarded Free Studentship for the first two semesters of the programme and renewal for III & IV semesters will be based on the performance in the II & III semesters.
                                                </td>
                                                <td>Exemption from payment of tuition fee per semester.</td>
                                            </tr>
                                            <tr>
                                                <td>3</td>
                                                <td>50% Free Studentship</td>
                                                <td>
                                                    Out of the remaining students who may secure not less than 6.5 CGPA and whose parental income is less than Rs.4.5 lakhs per annum will be awarded 50% tuition fee waiver.
                                                </td>
                                                <td>Exemption of 50% of Tuition Fees</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                    
                                  
                            </div>
                        </Fade>
                    }
                    </div>


                        {/*Guidelines*/}
                        
                    <div>
                            {guidelinesOpen && <Fade in={guidelinesOpen}>
                                <div className='c-lineheight2dot5 text-left'>
                                  
                                    <h4 className="mb-3">Apply Online</h4>
                                     <p>
                                       To Apply Online : <Link to="https://iittp.plumerp.co.in/prod/iittirupati/" target="_blank;" className="c-link">Click Here</Link>
                                    </p>
                                    <p>
                                       User Manual      : <Link to="#" target="_blank;" className="c-link">Click Here</Link>
                                    </p>
                                            
                            </div>
                        </Fade>
                    }
                </div>
            </Col>
        </Row>
    </Container>
        </section>
    );
}

export default Institute_PGscholarshipsEle;
